<i class="material-icons">{{ iconName }}</i>

<span>
  <ng-content></ng-content>
</span>
